import React from 'react';
import { Box, Typography } from '@mui/material';
import type { AnalyticsRecommendation } from '../../types/analytics';
import InsightFeedbackButtons from './InsightFeedbackButtons';

interface RecommendationCardProps {
  recommendation: AnalyticsRecommendation;
  weekStart: string;
  feedbackWritable: boolean;
}

const RecommendationCard: React.FC<RecommendationCardProps> = ({
  recommendation,
  weekStart,
  feedbackWritable,
}) => (
  <Box
    component="li"
    sx={{
      mb: 0.75,
      display: 'flex',
      alignItems: 'flex-start',
      gap: 1,
    }}
  >
    <Typography variant="body2" sx={{ fontSize: 13, flex: 1 }}>
      {recommendation.text}
      {recommendation.goal_name && (
        <Typography
          component="span"
          variant="caption"
          color="text.secondary"
          sx={{ ml: 1, fontStyle: 'italic' }}
        >
          ({recommendation.goal_name})
        </Typography>
      )}
    </Typography>
    <InsightFeedbackButtons
      insightKey={recommendation.insight_key}
      weekStart={weekStart}
      writable={feedbackWritable}
    />
  </Box>
);

export default RecommendationCard;
